export default "__VITE_ASSET__DACfAGWD__"